import { Complement } from './complement.model';

export class PaymentData {
  product: string;
  subscription: string;
  type: string;
  quantity: number;
  usuarios: number;
  usuariosLabel: string;
  transactions: string;
  transactionType: string;
  pricing: number;
  pricingInfo: string;
  pricingUSD?: string;
  complements: Complement[] = [];
}
